/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Professional_SummaryInputs */

const en_resume_editor_professional_summary = /** @type {(inputs: Resume_Editor_Professional_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professional Summary`)
};

const de_resume_editor_professional_summary = /** @type {(inputs: Resume_Editor_Professional_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const fr_resume_editor_professional_summary = /** @type {(inputs: Resume_Editor_Professional_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume professionnel`)
};

const es_resume_editor_professional_summary = /** @type {(inputs: Resume_Editor_Professional_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen profesional`)
};

const it_resume_editor_professional_summary = /** @type {(inputs: Resume_Editor_Professional_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo professionale`)
};

const nl_resume_editor_professional_summary = /** @type {(inputs: Resume_Editor_Professional_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionele samenvatting`)
};

const pl_resume_editor_professional_summary = /** @type {(inputs: Resume_Editor_Professional_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podsumowanie zawodowe`)
};

const fi_resume_editor_professional_summary = /** @type {(inputs: Resume_Editor_Professional_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ammatillinen yhteenveto`)
};

const da_resume_editor_professional_summary = /** @type {(inputs: Resume_Editor_Professional_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionel oversigt`)
};

const sv_resume_editor_professional_summary = /** @type {(inputs: Resume_Editor_Professional_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionell sammanfattning`)
};

/**
* | output |
* | --- |
* | "Professional Summary" |
*
* @param {Resume_Editor_Professional_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_professional_summary = /** @type {((inputs?: Resume_Editor_Professional_SummaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Professional_SummaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_professional_summary(inputs)
	if (locale === "fr") return fr_resume_editor_professional_summary(inputs)
	if (locale === "es") return es_resume_editor_professional_summary(inputs)
	if (locale === "it") return it_resume_editor_professional_summary(inputs)
	if (locale === "nl") return nl_resume_editor_professional_summary(inputs)
	if (locale === "pl") return pl_resume_editor_professional_summary(inputs)
	if (locale === "fi") return fi_resume_editor_professional_summary(inputs)
	if (locale === "da") return da_resume_editor_professional_summary(inputs)
	if (locale === "sv") return sv_resume_editor_professional_summary(inputs)
	return en_resume_editor_professional_summary(inputs)
});